import { Box, Card, CardContent, CircularProgress, Grid, Typography, Tabs, Tab } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { authState, env } from '../../../api';
import { abelAPI } from '../../../api/abel';
import { StyledSmartLink } from '../../../components/common';
import { DifficultyTrendSection } from './DifficultyTrendSection';
import { LatestBlockMinedSection } from './LatestBlockMinedSection';
import { OSLogo } from '../../QuickstartGuide/QuickstartGuide';
import { ISection, loadBalancerAPI } from '../../../api/load-balancer';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { HashUnit } from '../../../abelcommon';
import { useHashrateRevenueCalculator } from '../../../abelcommon/hooks/useHashrateRevenueCalculator';

export function Home() {
  const {
    data: summaryInfoData,
    isLoading: isLoadingSummaryInfo,
    error: errorSummaryInfo,
    refetch: refetchSummaryInfo,
  } = abelAPI.hookWrapper.useSummaryInfo();
  const {
    data: summaryData,
    isLoading: isLoadingSummary,
    error: errorSummary,
    refetch: refecthSummary,
  } = loadBalancerAPI.hookWrapperQuery.useGetDataSummary();
  const { data: revenuePerDay } = useHashrateRevenueCalculator([1000], HashUnit.MH, 0.0);
  const rpd = revenuePerDay.map((r) => r.revenue);
  const [filteredData, setFilteredData] = useState<ISection[]>([]);
  const { t, i18n } = useTranslation();
  const authStateValue = useRecoilValue(authState);

  React.useEffect(() => {
    document.title = env.title + ` | ${t('navigatorPage.home')}`;
  }, [t]);

  let languageCode: string;
  if (authStateValue?.user?.languageCode) {
    languageCode = authStateValue.user.languageCode;
  } else {
    languageCode = i18n.language;
  }

  const {
    data: allSectionData,
    isLoading: isLoadingSectionData,
    error: errorSectionData,
  } = loadBalancerAPI.hookWrapperQuery.useGetAllSection({ enabled: true }, languageCode);

  useEffect(() => {
    if (allSectionData) {
      const filteredSections = allSectionData.filter((section) =>
        ['#hive_os', '#linux', '#windows'].includes(section.hashHyperLink)
      );
      setFilteredData(filteredSections);
    }
  }, [allSectionData]);

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Card>
          <CardContent sx={{ overflow: 'auto', fontWeight: 600, fontSize: '1rem' }}>
            {t('homePage.supportedPlatforms')}: {isLoadingSectionData && <CircularProgress />}
            {errorSectionData && (
              <Box>
                <Typography variant="h6" color="error">
                  {t('homePage.failedToLoadSections')}
                </Typography>
              </Box>
            )}
            {!isLoadingSectionData && !errorSectionData && (
              <Grid container spacing={4} sx={{ justifyContent: 'center', mt: 1 }}>
                {filteredData.map((section) => (
                  <Grid item xs={12} sm={6} lg={4} key={section.id}>
                    <StyledSmartLink to={`/home/guide${section.hashHyperLink}`}>
                      <OSLogo section={section} />
                    </StyledSmartLink>
                  </Grid>
                ))}
              </Grid>
            )}
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12}>
        <LatestBlockMinedSection
          globalNetworkInfo={summaryInfoData}
          globalNetworkInfoLoading={isLoadingSummaryInfo || isLoadingSummary}
          globalNetworkInfoError={errorSummaryInfo || errorSummary}
          refetchGlobalNetworkInfo={() => {
            refetchSummaryInfo();
            refecthSummary();
          }}
          revenuePerDay={rpd}
          summaryDataInfo={summaryData}
        />
      </Grid>
      <Grid item xs={12}>
        <DifficultyTrendSection
          globalNetworkInfo={summaryInfoData}
          globalNetworkInfoLoading={isLoadingSummaryInfo || isLoadingSummary}
          globalNetworkInfoError={errorSummaryInfo || errorSummary}
        />
      </Grid>
    </Grid>
  );
}

export default Home;
